import { ConnectorStatus, getConnectorStatusGroup } from '../../../shared/enums/status';

type MarkerColor = 'green' | 'blue' | 'yellow' | 'gray';

interface ConnectorInfo {
  connectorId: number;
  status: string;
}

export const MARKER_COLOR_MAP: Record<MarkerColor, string> = {
  green: '#1DEF83',
  blue: '#3B82F6',
  yellow: '#F59E0B',
  gray: '#94A3B8',
};

function groupOf(status: string): ReturnType<typeof getConnectorStatusGroup> {
  const normalized = status.replace(/\s+/g, '') as ConnectorStatus; // 'Suspended EV' -> 'SuspendedEV'
  return getConnectorStatusGroup(normalized);
}

export function getMarkerColor(
  connectors?: ConnectorInfo[],
  stationStatus?: string,
): MarkerColor {
  if (!connectors || connectors.length === 0) {
    return stationStatus === 'active' ? 'green' : 'gray';
  }

  const groups = connectors.map((c) => groupOf(c.status));

  if (groups.some((g) => g === 'in-use')) return 'blue';
  if (groups.some((g) => g === 'inactive')) return 'yellow';
  if (groups.every((g) => g === 'available')) return 'green';

  return 'gray';
}

export function getAvailableCount(connectors?: ConnectorInfo[]): number {
  if (!connectors) return 0;
  return connectors.filter((c) => groupOf(c.status) === 'available').length;
}

export function getConnectorStatusColor(status?: string): string {
  if (!status) return MARKER_COLOR_MAP.gray;

  const group = groupOf(status);

  switch (group) {
    case 'available':
      return MARKER_COLOR_MAP.green;
    case 'in-use':
      return MARKER_COLOR_MAP.blue;
    case 'inactive':
      return MARKER_COLOR_MAP.yellow;
    case 'offline':
    default:
      return MARKER_COLOR_MAP.gray;
  }
}
